import { render, staticRenderFns } from "./DemandHall.vue?vue&type=template&id=1948d4ec&scoped=true"
import script from "./DemandHall.vue?vue&type=script&lang=js"
export * from "./DemandHall.vue?vue&type=script&lang=js"
import style0 from "./DemandHall.vue?vue&type=style&index=0&id=1948d4ec&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1948d4ec",
  null
  
)

export default component.exports